module.exports = __webpack_public_path__ + "img/modern_pink.10469fbf.png";